/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
import '../banking/common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbstatements": {
        "nested": {
          "CheckingStatement": {
            "fields": {
              "statementToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "activityStartAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 2,
                "rule": "optional"
              },
              "activityEndAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "downloadUrl": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "month": {
                "type": "uint32",
                "id": 5,
                "rule": "optional"
              },
              "year": {
                "type": "uint32",
                "id": 6,
                "rule": "optional"
              }
            }
          },
          "CheckingStatementFilter": {
            "fields": {
              "owner": {
                "type": ".squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              },
              "accountIds": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "startAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "endAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "Statement": {
            "fields": {
              "id": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "activityStartAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 2,
                "rule": "optional"
              },
              "activityEndAt": {
                "type": ".squareup.common.time.DateTime",
                "id": 3,
                "rule": "optional"
              },
              "downloadUrl": {
                "type": "string",
                "id": 4,
                "rule": "optional"
              },
              "statementYearMonth": {
                "type": ".squareup.common.time.YearMonth",
                "id": 5,
                "rule": "optional"
              }
            }
          },
          "StatementFilter": {
            "fields": {
              "owner": {
                "type": ".squareup.banking.Owner",
                "id": 1,
                "rule": "optional"
              },
              "accountIds": {
                "type": "string",
                "id": 2,
                "rule": "repeated"
              },
              "startAt": {
                "type": ".squareup.common.time.YearMonth",
                "id": 3,
                "rule": "optional"
              },
              "endAt": {
                "type": ".squareup.common.time.YearMonth",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "StatementQuery": {
            "fields": {
              "filter": {
                "type": ".squareup.bbstatements.StatementFilter",
                "id": 1,
                "rule": "optional"
              },
              "sort": {
                "type": ".squareup.bbstatements.StatementQuery.Sort",
                "id": 2,
                "rule": "optional"
              }
            },
            "nested": {
              "Sort": {
                "fields": {
                  "field": {
                    "type": ".squareup.bbstatements.StatementQuery.Sort.SortField",
                    "id": 1,
                    "rule": "optional",
                    "options": {
                      "default": "ACTIVITY_STARTED_AT"
                    }
                  },
                  "order": {
                    "type": ".squareup.bbstatements.StatementQuery.Sort.SortOrder",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": "DESC"
                    }
                  }
                },
                "nested": {
                  "SortField": {
                    "values": {
                      "ACTIVITY_STARTED_AT": 0
                    }
                  },
                  "SortOrder": {
                    "values": {
                      "DESC": 0,
                      "ASC": 1
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbstatements?.nested?.CheckingStatement && !$root.nested?.squareup?.nested?.bbstatements?.nested?.CheckingStatementFilter && !$root.nested?.squareup?.nested?.bbstatements?.nested?.Statement && !$root.nested?.squareup?.nested?.bbstatements?.nested?.StatementFilter && !$root.nested?.squareup?.nested?.bbstatements?.nested?.StatementQuery && !$root.nested?.squareup?.nested?.bbstatements?.nested?.StatementQuery?.nested?.Sort && !$root.nested?.squareup?.nested?.bbstatements?.nested?.StatementQuery?.nested?.Sort?.nested?.SortField && !$root.nested?.squareup?.nested?.bbstatements?.nested?.StatementQuery?.nested?.Sort?.nested?.SortOrder) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE CheckingStatement @ squareup/bbstatements/model.proto at 12:1
 */
export const CheckingStatement = $root.lookupType('squareup.bbstatements.CheckingStatement');
fixType(CheckingStatement);
Builder.createAndAttachToType(CheckingStatement);
/**
 * SOURCE CheckingStatementFilter @ squareup/bbstatements/model.proto at 21:1
 */
export const CheckingStatementFilter = $root.lookupType('squareup.bbstatements.CheckingStatementFilter');
fixType(CheckingStatementFilter, {
  owner: {
    required: true
  }
});
Builder.createAndAttachToType(CheckingStatementFilter);
/**
 * SOURCE Statement @ squareup/bbstatements/model.proto at 35:1
 */
export const Statement = $root.lookupType('squareup.bbstatements.Statement');
fixType(Statement);
Builder.createAndAttachToType(Statement);
/**
 * SOURCE StatementFilter @ squareup/bbstatements/model.proto at 43:1
 */
export const StatementFilter = $root.lookupType('squareup.bbstatements.StatementFilter');
fixType(StatementFilter, {
  owner: {
    required: true
  }
});
Builder.createAndAttachToType(StatementFilter);
/**
 * SOURCE StatementQuery @ squareup/bbstatements/model.proto at 58:1
 */
export const StatementQuery = $root.lookupType('squareup.bbstatements.StatementQuery');
fixType(StatementQuery);
Builder.createAndAttachToType(StatementQuery);
/**
 * SOURCE Sort @ squareup/bbstatements/model.proto at 59:3
 */
StatementQuery.Sort = $root.lookupType('squareup.bbstatements.StatementQuery.Sort');
fixType(StatementQuery.Sort);
Builder.createAndAttachToType(StatementQuery.Sort);
/**
 * SOURCE SortField @ squareup/bbstatements/model.proto at 60:5
 */
StatementQuery.Sort.SortField = $root.lookupEnum('squareup.bbstatements.StatementQuery.Sort.SortField').values;
/**
 * SOURCE SortOrder @ squareup/bbstatements/model.proto at 63:5
 */
StatementQuery.Sort.SortOrder = $root.lookupEnum('squareup.bbstatements.StatementQuery.Sort.SortOrder').values;